<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              We ensure that you are informed and always up-to-date
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Corporate Communications, Marketing and Public Relations</h1>
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                The Corporate Communications, Marketing and Public Relations (CCMPR) department is the information
                hub through which Northern Caribbean University (NCU) communicates with and relates to  its internal and external publics.
                <br><br>
                The department also serves the internal public of the university by being actively involved in the planning of all major
                events and providing support services through our graphics design team. Communication to the internal public also comes in
                the form of the ‘E-bulletin’, which notifies the university population of upcoming events and other important matters on a daily basis.
                <br><br>
                CCMPR also has the responsibility to market and promote the university’s programmes and services utilizing a variety of communication
                channels including the various social media platforms (facebook, instagram, twitter, youtube), which are handled by the department.
                <br><br>
                A critical role and function of CCMPR is to promote, protect and preserve the NCU brand as a Christ-centred and values-based educational institution.

              </div>

              <div>
                <div>
                  <div class="uk-child-width-1-2@s uk-child-width-1-2@l " uk-grid>
                    <div>
                      <img class="uk-border-circle" src="../assets/ccmpr.png" width="200" height="200" alt="Border circle">
                    </div>
                    <div>
                      <img class="uk-border-circle" src="../assets/ccmpr1.png" width="200" height="200" alt="Border circle">
                    </div>
                  </div>
                </div>
                <br><br>
                <div>
                  <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>
                    <div>
                      <img class="uk-border-circle" src="../assets/ccmpr2.png" width="200" height="200" alt="Border circle">
                    </div>
                    <div>
                      <img class="uk-border-circle" src="../assets/ccmpr3.jpg" width="200" height="200" alt="Border circle">
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!--<div class="uk-child-width-1-1@m">
              <hr class="uk-divider-icon">

            </div>-->
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "ccmpr",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU CCMPR',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Corporate Communication, Marketing and Public Relations Department at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
